﻿import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';

import { BookingFlowContext } from '../BookingFlowContext'
import { products } from '../Endpoints' 
import { TwoColumnWrapper } from '../../../../../Resources/Scripts/_Shared/elements/ColumnWrapper'
import { InputWithLabel } from '../../../../../Resources/Scripts/_Shared/elements/InputWithLabel'
import { Error } from '../../../../../Resources/Scripts/_Shared/elements/Error'

const OrderOverviewDiscount = (props) => {
  const { bookingFlowContext } = useContext(BookingFlowContext);
  const lang = bookingFlowContext.localization.orderOverview.discount;

  const locale = bookingFlowContext.country;
  const selectedLocale = locale === 'no' ? 'nb' : locale === 'se' ? 'sv' : locale;
  moment().locale(selectedLocale);

  const [disable, setDisable] = useState(false)
  const [promoCode, setPromoCode] = useState({ text: '' })
  const [promoCodeEnabled, setPromoCodeEnabled] = useState(false)

  const discountClickHandler = async () => {
    if (!promoCodeEnabled && !promoCode.text || promoCode.text.trim().length === 0) return
    //if (promoCodeEnabled) {
    //  //const updatedQuote = !parsedQuote ? await products.updateSalesOrder({ form: updateQuoteForm, bookingflowPage: bookingFlowContext.episerver.bookingflowUrl }, bookingFlowContext.useMockedData) : parsedQuote;

    //  props.quoteUpdateEvent(null, null);
    //  setPromoCodeEnabled(false);
    //  return;
    //}

    if (props.pending)
      return;

    props.setPending(true);
    props.setError(null);
    setDisable(true);

    const updateQuoteForm = {
      OrderId: props.quoteId,
      Data: { PromotionCode: promoCodeEnabled ? '' : promoCode.text },
      ProcessType: props.processType,
    }

    const updatedQuote = await products.updateSalesOrder({ form: updateQuoteForm, bookingflowPage: bookingFlowContext.episerver.bookingflowUrl }, bookingFlowContext.useMockedData);

    if (updatedQuote.status === 200) {
      if (promoCodeEnabled) {
        setPromoCode('');
        props.quoteUpdateEvent(null, updatedQuote);
      } else props.quoteUpdateEvent(promoCode.text, updatedQuote);

      setPromoCodeEnabled(!promoCodeEnabled);
    } else {
      props.setError({ error: true, errorText: updatedQuote.errorMessage, errorType: 'updatedQuote' });
    }
    props.setPending(false);
    setDisable(false);
  };

  useEffect(() => {
    if (!props.currentPromotionCode || promoCode.text) return
    setPromoCode({ text: props.currentPromotionCode })
    setPromoCodeEnabled(true)
  }, [props.currentPromotionCode])

  useEffect(() => {
    if (!promoCode.text) props.setError(null);
  }, [promoCode])

  const handleKeyDown = (e) => e.key === 'Enter' && discountClickHandler();

  return (
    <div className="single-step__wrapper">
      <TwoColumnWrapper>
        <div className="single-step__discount">
          <InputWithLabel inputType="text" text="" placeholder={lang.inputplaceholder} value={promoCode} setValue={setPromoCode} disabled={disable || props.disabled || promoCodeEnabled} keyDown={handleKeyDown} />
          {!promoCodeEnabled && <button className="single-step__button" disabled={disable || props.disabled || !promoCode.text || promoCode.text.trim().length === 0} aria-busy={props.pending} onClick={discountClickHandler}>{lang.button}</button>}
          {promoCodeEnabled && <button className="single-step__button single-step__button--cancel" disabled={disable || props.disabled} aria-busy={props.pending} onClick={discountClickHandler}>{lang.buttonremove}</button>}
        </div>
        {(props.error && props.error.errorText?.length > 0 && props.error.errorType === 'updatedQuote' && promoCode.text) && <Error text={props.error.errorText} modifierClass="blue" />}
      </TwoColumnWrapper>
    </div>
  )
}

export default OrderOverviewDiscount;
